import React from 'react';
import {IClassNameProps} from '@bem-react/core';
import {KitchenService} from '../../../../3d/services/KitchenService/KitchenService';
import {cnKitchenParams} from '../KitchenParams';
import {useTranslation} from 'react-i18next';
import {IHandleData} from '../../../../../common-code/interfaces/materials/IHandleData';
import {useSelector} from 'react-redux';
import {AppState} from '../../../../redux/AppStore';
import {Tip} from '../../../components/Tip/Tip';
import {OBJECT_SELECT_TYPE_HANDLE} from '../../../../constants';
import {IMaterialData} from '../../../../../common-code/interfaces/materials/IMaterialData';
import {AccessoriesGroup} from '../../Accessories/Group/Accessories-Group';
import {cnAccessories} from '../../Accessories/Accessories';
import {IApronData} from '../../../../../common-code/interfaces/materials/IApronData';
import {ICornerData} from '../../../../../common-code/interfaces/materials/ICornerData';
import {IFacadeMaterialData} from '../../../../../common-code/interfaces/materials/IFacadeMaterialData';
import {IPlinthData} from '../../../../../common-code/interfaces/materials/IPlinthData';
import {ITabletopData} from '../../../../../common-code/interfaces/materials/ITabletopData';

export interface IKitchenParamsHandlesProps extends IClassNameProps {
    service: KitchenService;
}

export const KitchenParamsHandles: React.FC<IKitchenParamsHandlesProps> = ({className, service}) => {
    const {t} = useTranslation();
    const bottomHandle: IHandleData | undefined = useSelector((state: AppState) => state.wizard.bottomHandle);
    const topHandle: IHandleData | undefined = useSelector((state: AppState) => state.wizard.topHandle);
    const handles: IHandleData[] | undefined = useSelector((state: AppState) => state.wizard.handles);

    const onSelectBottomHandle = (handle: IApronData | IMaterialData | ICornerData | IFacadeMaterialData | IPlinthData | ITabletopData | IHandleData) => {
        service.setBottomHandle(handle as IHandleData, true);
    }
    const onSelectTopHandle = (handle: IApronData | IMaterialData | ICornerData | IFacadeMaterialData | IPlinthData | ITabletopData | IHandleData) => {
        service.setTopHandle(handle as IHandleData, true);
    }
    return (
        <div className={cnKitchenParams('Handles', [className])}>
            {topHandle && handles ?
                <div className={cnKitchenParams('Item')}>
                    <div className={cnKitchenParams('ItemTitle')}>
                        {t('Верхние ручки')}
                        <Tip directionIcon={'right'} message={<>
                            <p>Для верхних модулей можно изменить ручку.</p>
                        </>} className={cnKitchenParams('TitleTip')}/>
                    </div>
                    <AccessoriesGroup type={OBJECT_SELECT_TYPE_HANDLE} title={t('Верхние ручки')}
                                      className={cnAccessories('Group')}
                                      service={service}
                                      list={handles}
                                      selectObject={topHandle}
                                      onSelectObject={onSelectTopHandle}
                                      checkbox={true}
                    />
                </div> : null}
            {bottomHandle && handles ?
                <div className={cnKitchenParams('Item')}>
                    <div className={cnKitchenParams('ItemTitle')}>
                        {t('Нижние ручки')}
                        <Tip directionIcon={'right'} message={<>
                            <p>Для нижних модулей можно изменить ручку.</p>
                        </>} className={cnKitchenParams('TitleTip')}/>
                    </div>
                    <AccessoriesGroup type={OBJECT_SELECT_TYPE_HANDLE} title={t('Нижние ручки')}
                                      className={cnAccessories('Group')}
                                      service={service}
                                      list={handles}
                                      selectObject={bottomHandle}
                                      onSelectObject={onSelectBottomHandle}
                                      checkbox={true}
                    />
                </div> : null}
        </div>
    );
};